import { action,observable } from "mobx";
import {post} from "../../services/ajax-calls.service";
class MedicalSummaryStore { 

   
    @observable total_participants = 0;
    @observable total_spend = 0;
    @observable pmpm = 0;
    @observable total_claims = 0;
    @observable average_claim_cost = 0;
    @observable average_in_patient_day = 0; 
    @observable top_diagnosis = [];
    @observable top_participants = [];
    @observable top_procedures = [];
    @observable in_patient_vs_out_patient = []
    @observable pmpm_claims_count_claims_cost = [];

    @observable url = "/api/v1/medicalActions/summary";

    

    @action getTotalParticipants = async(data) => {
        this.total_participants = 0;
        let response = await post(`${this.url}/getTotalParticipants`, data);
        this.total_participants = response.data[0].total_participants;
    }
    @action getTotalSpend = async(data) => {
        this.total_spend = 0;
        let response = await post(`${this.url}/getTotalSpend`, data);
        this.total_spend = response.data[0].total_spend
    }
    @action getPMPM = async(data) => {
        this.pmpm = 0;
        let response = await post(`${this.url}/getPMPM`, data);
        this.pmpm = response.data[0]?.pmpm ?? 0
    }
    @action getTotalClaims = async(data) => {
        this.total_claims = 0;
        let response = await post(`${this.url}/getTotalClaims`, data);
        this.total_claims = response.data[0]?.claims_count ?? 0
    }
    @action getAverageClaimCost = async(data) => {
        this.average_claim_cost = 0;
        let response = await post(`${this.url}/getAverageClaimCost`, data);
        this.average_claim_cost = response.data[0]?.average_allowed_amount ?? 0
    }
    @action getAverageInPatientDay = async(data) => {
        this.average_in_patient_day = 0;
        let response = await post(`${this.url}/getAverageInPatientDay`, data);
        this.average_in_patient_day = response.data[0]?.days_of_service ?? 0
    }
    @action getLeftMiddleGraph = async(data) => {
       
        let response = await post(`${this.url}/getLeftMiddleGraph`, data);
        this.pmpm_claims_count_claims_cost = response.data
    }
    @action getRightMiddleGraph = async(data) => {
        let response = await post(`${this.url}/getRightMiddleGraph`, data);
        this.in_patient_vs_out_patient = response.data
    }
    @action getTopDiagnosis = async(data) => {
        this.top_diagnosis = [];       
        let response = await post(`${this.url}/getTopDiagnosis`, data);
        this.top_diagnosis = response.data
    }
    @action getTopProcedures = async(data) => {
        this.top_procedures = [];
        let response = await post(`${this.url}/getTopProcedures`, data);
        this.top_procedures  = response.data;
    }
    @action getTopParticipants = async(data) => {
        this.top_participants = [];
        let response = await post(`${this.url}/getTopParticipants`, data);
        this.top_participants = response.data
    }
    
}

export default MedicalSummaryStore;